import { AB_PRICING_NEW_ENT } from "@/constants/ABMng";
import useAppStore from "@/context/store";
import { isGdMerged } from "@/utils/gaoding";
import useABTest from "@/utils/hooks/useABtest";
import { useGdVipInfo } from "@/utils/hooks/useGdVipInfo";
import { GdVipCard } from "./gaoding";
import { HBVipCard } from "./huaban";

export function VipPanel() {
  const user = useAppStore((s) => s.user);
  const { data: gdVipInfo } = useGdVipInfo();

  // ABTest: 会员订购入口优化实验
  const pricingEntABTest = useABTest(AB_PRICING_NEW_ENT);

  // 获取用户会员状态详情
  const getMembershipDetails = () => {
    if (!gdVipInfo) {
      return {
        isNonMember: true,
        isPlusMember: false,
        hasMaterialVip: false,
        hasTemplateVip: false,
      };
    }

    // 大会员
    const isPlusMember = !!gdVipInfo.isPlus;

    // 素材会员（未过期）
    const hasMaterialVip =
      gdVipInfo.materialVip?.length > 0 && !gdVipInfo.isMaterialVipExpired;

    // 模板会员（未过期）
    const hasTemplateVip =
      gdVipInfo.gdesignProductMod && !gdVipInfo.isGdesignVipExpired;

    const isNonMember = !isPlusMember && !hasMaterialVip && !hasTemplateVip;

    return {
      isNonMember,
      isPlusMember,
      hasMaterialVip,
      hasTemplateVip,
    };
  };

  // AB实验逻辑：根据会员类型决定显示策略
  const getDisplayStrategy = () => {
    // 如果AB实验没有命中，按原逻辑处理
    if (!pricingEntABTest.value) {
      return {
        hidePanel: false,
        hideMaterialVip: false,
        hideTemplateVip: false,
        showPlusMemberCard: false,
      };
    }

    const { isPlusMember, hasMaterialVip, hasTemplateVip } =
      getMembershipDetails();

    // 获取权益过期状态
    const isMaterialVipExpired = gdVipInfo?.isMaterialVipExpired;
    const isTemplateVipExpired = gdVipInfo?.isGdesignVipExpired;

    // 大会员：不做处理（显示完整面板）
    if (isPlusMember) {
      return {
        hidePanel: false,
        hideMaterialVip: false,
        hideTemplateVip: false,
        showPlusMemberCard: false,
      };
    }

    /**
     * 1. 当前是会员：只展示在期会员
     * 2. 当前不是会员
     * 2.1 有过期会员——展示卡片（稿定模板+大会员，花瓣素材+大会员）
     * 2.2  无过期会员（未开通过）——不展示卡片
     */

    // 1. 当前存在会员，展示在期会员卡片
    if (hasMaterialVip || hasTemplateVip) {
      return {
        hidePanel: false,
        hideMaterialVip: !hasMaterialVip,
        hideTemplateVip: !hasTemplateVip,
        showPlusMemberCard: false,
      };
    }

    // 2. 当前不存在会员
    if (!hasMaterialVip && !hasTemplateVip) {
      // 2.1 有过期会员，展示购买素材购买  + 大会员卡片
      if (isMaterialVipExpired || isTemplateVipExpired) {
        return {
          hidePanel: false,
          hideMaterialVip: false,
          hideTemplateVip: true,
          showPlusMemberCard: true,
        };
      }
      // 2.2 无过期会员，不展示任何卡片
      return {
        hidePanel: true,
        hideMaterialVip: true,
        hideTemplateVip: true,
        showPlusMemberCard: false,
      };
    }

    // 默认情况（保持向后兼容）
    return {
      hidePanel: false,
      hideMaterialVip: false,
      hideTemplateVip: false,
      showPlusMemberCard: false,
    };
  };

  const displayStrategy = getDisplayStrategy();

  // 如果AB实验命中且需要隐藏整个面板，则不渲染
  if (displayStrategy.hidePanel) {
    return null;
  }

  return isGdMerged(user) ? (
    <GdVipCard displayStrategy={displayStrategy} />
  ) : (
    <HBVipCard />
  );
}
